// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_HWU","left":"styles_left__1TtfC","desktopActions":"styles_desktopActions__3Qw6-","title":"styles_title__3Hy7c"};